















import Vue from 'vue'
import ClioNav from '@/components/Navbar.vue'
export default Vue.extend({
	components: {ClioNav}
})
